import { DateTime } from 'luxon';

/**
 * Convert a user-inputted date string into a UTC timestamp
 * @param inputDate Date in the format 'MM-dd-yyyy'
 * @returns DateTime value for the input date
 */
const inputDateToDateTime = (inputDate?: string): DateTime<true> | undefined => {
  if (!inputDate || inputDate.length === 0) {
    return undefined;
  }

  const dateTime = DateTime.fromFormat(inputDate, 'MM-dd-yyyy');

  if (!dateTime.isValid) {
    return undefined;
  }

  return dateTime;
};

export default inputDateToDateTime;
